<template>
    <div>
        <CRow>
            <CCol md="8" lg="8">
                <CButton
                    class="mb-1"
                    style="width:auto"
                    variant="ghost"
                    size="lg"
                    color="success"
                    @click="actualizar"
                    :disabled="isActualizandoEmpresas"
                >
                    <CIcon :content="$options.freeSet.cilLoopCircular" :class="classActualizar" /> {{textoBtnActualizarEmpresas}}
                </CButton>
                <CButton
                    class="ml-1 mb-1"
                    style="width:auto"
                    size="sm"
                    v-show="mensajesActualizacion.length>0"
                    @click="mostrarMensajes = !mostrarMensajes"
                    v-c-tooltip.hover="{content:`${(mostrarMensajes)?'Ocultar':'Mostrar'} mensajes actualización`, placement:'down'}"
                >
                    <CIcon :content="(mostrarMensajes)?$options.freeSet.cilChevronTop:$options.freeSet.cilChevronBottom" /> 
                </CButton>
            </CCol>
        </CRow>
        <!--<CRow>
            <CWidgetDropdown color="info" header="9.823" text="Members online">
        <template #default>
          <CDropdown
            color="transparent p-0"
            placement="bottom-end"
            :caret="false"
          >
            <template #toggler-content>
              <CIcon name="cil-location-pin"/>
            </template>
            <CDropdownItem>Action</CDropdownItem>
            <CDropdownItem>Another action</CDropdownItem>
            <CDropdownItem>Something else here...</CDropdownItem>
            <CDropdownItem disabled>Disabled action</CDropdownItem>
          </CDropdown>
        </template>
        <template #footer>
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[1, 18, 9, 17, 34, 22, 11]"
            point-hover-background-color="info"
            :options="{ elements: { line: { tension: 0.00001 }}}"
            label="Members"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
        </CRow>-->
        <CRow v-show="mostrarMensajes">
            <CCol md="8" lg="8">
                <a-table
                :row-key="empresa => empresa.idEmpresa"
                :columns="columnasMensajesAct" 
                :data-source="mensajesActualizacion"
                :scroll="{ y: 300 }"
                class="components-table-demo-nested mt-3" 
                size="small" 
                style="overflow:auto;">
                    <slot slot="mensajes" slot-scope="mensaje">
                        <CAlert show color="info" :key="index" v-for="(msj, index) in mensaje.mensajes">
                            {{msj.mensaje}}
                        </CAlert>
                    </slot>
                </a-table>
            </CCol>
        </CRow>
        <CRow>
            <CCol md="12" lg="12">
                <CCard accent-color="info">
                    <CCardHeader>
                        <h4>Envío de {{(tipoDocumentos.length==1)?tipoDocumentoSelected.nombreDocumento:'Documentos'}}</h4>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol md="12" v-show="(periodos.length > 0)">
                                Seleccionar último periodo en proceso
                                <CSwitch
                                    width="150px"
                                    class="mx-1 align-middle mb-2"
                                    shape="pill"
                                    variant="outline"
                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                    :checked="selectPeriodoActual"
                                    @update:checked="selectPeriodoActual = !selectPeriodoActual; seleccionarPeriodoActual()"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="3">
                                <multiselect class="m-0 d-inline-block mb-2" 
                                    v-model="periodoSelected"
                                    deselect-label="" 
                                    label="nombrePeriodo" 
                                    placeholder="Periodo" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="periodos" 
                                    :searchable="true"
                                    :loading="isLoadingPeriodos"
                                    :disabled="selectPeriodoActual"
                                    @select="seleccionarPeriodo"
                                >
                                </multiselect>
                            </CCol>
                            <CCol md="3">
                                <multiselect class="m-0 d-inline-block mb-2" 
                                    v-model="mesSelected"
                                    deselect-label="" 
                                    label="nombreMes" 
                                    placeholder="Mes" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="(periodoSelected == null)?[]:periodoSelected.meses" 
                                    :searchable="true"
                                    :loading="isLoadingMes"
                                    :disabled="(periodoSelected == null || selectPeriodoActual)?true:false"
                                    @select="seleccionarMeses"
                                    >
                                </multiselect>
                            </CCol>
                            <CCol md="3">
                                <!--<span v-if="tipoDocumentos.length==1"
                                    v-c-tooltip.hover="{content:(tipoDocumentos.length==1)?'Solo existe un documento('+tipoDocumentoSelected.nombreDocumento+')':'', placement:'top'}">
                                    {{tipoDocumentoSelected.nombreDocumento}}
                                </span>-->
                                <multiselect class="m-0 d-inline-block mb-2"
                                    v-if="!(tipoDocumentos.length==1)"
                                    v-model="tipoDocumentoSelected"
                                    deselect-label="" 
                                    label="nombreDocumento" 
                                    placeholder="Documento" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="tipoDocumentos" 
                                    :searchable="true"
                                    :loading="isLoadingTipoDocumentos"
                                    v-c-tooltip.hover="{content:'Documento', placement:'top'}"
                                    :disabled="(periodoSelected == null || mesSelected == null)?true:false"
                                    @select="obtenerEmpresas"
                                >
                                </multiselect>
                            </CCol>
                        </CRow>
                        <CRow>
                            
                            <CCol md="4">
                                <multiselect
                                    v-show="tipoUserAdmin"
                                    class="mb-2"
                                    :custom-label="customLabelEmp"
                                    v-model="empSelected"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Quitar"
                                    selectLabel="Agregar"
                                    placeholder="Buscar Empresas" 
                                    label="nombreEmpresa" 
                                    track-by="codEmpresa" 
                                    :options="empresasInfo" 
                                    :multiple="true"
                                    @select="filtrarEmpr"
                                    @remove="rmvEmpSel"></multiselect>
  
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="3">
                                <CButton class="btnPrincipalVapp" @click="refrescarEmpresas" :disabled="isRefrescando">
                                    <CIcon :content="$options.freeSet.cilLoopCircular" :class="classRefrescarEmpresas" />
                                    Refrescar Información
                                </CButton>
                            </CCol>
                        </CRow>
                        
                        <CRow>
                            <CCol md="12">
                                <a-table
                                    :row-key="empresa => empresa.idEmpresa"
                                    @expand="expandirEmpresa"
                                    :columns="columns" 
                                    :data-source="empresasFiltradas"
                                    :pagination="paginacionEmpresas"
                                    :scroll="{ y: 400 }"
                                    :locale="locale"
                                    :loading="isLoadingEmpresas"
                                    class="components-table-demo-nested mt-3" 
                                    size="small" 
                                    style="overflow:auto;"
                                    @change="cambioPaginaEmpresas">

                                    <span slot="customTitle">
                                        Nombre Empresa
                                    </span>
                                    
                                    <span slot="nombreEmpresa" slot-scope="empresa">
                                        ({{empresa.codEmpresa}}) {{empresa.nombreEmpresa}}
                                    </span>

                                    <span slot="notificarPor" slot-scope="empresa">
                                        
                                        <CRow>
                                            <CCol md="6" class="text-left">
                                                <div class="float-left text-right" style="width:50%; text-overflow: ellipsis;">Correo</div>
                                                <div class="float-left" style="width:50%">
                                                    <CSwitch
                                                        width="150px"
                                                        class="mx-1 align-middle"
                                                        size="sm" 
                                                        color="success" 
                                                        shape="pill"
                                                        variant="outline"
                                                        v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                        :checked="empresa.notificar.mail"
                                                        @update:checked="empresa.notificar.mail = !empresa.notificar.mail;"
                                                    />
                                                </div>
                                            </CCol>
                                            <CCol md="6" class="text-left">
                                                <CRow>
                                                    <CCol md="6" class="text-left">Plataforma</CCol>
                                                <!--<div class="text-right" style="width:50%; text-overflow: ellipsis;">
                                                    Plataforma
                                                </div>
                                                <div style="width:50%">
                                                </div>-->
                                                    <CCol md="6" class="text-left">
                                                        <CSwitch
                                                            width="150px"
                                                            class="mx-1 align-middle" 
                                                            size="sm"
                                                            color="success" 
                                                            shape="pill"
                                                            variant="outline"
                                                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                                            :checked="empresa.notificar.plataforma"
                                                            @update:checked="empresa.notificar.plataforma = !empresa.notificar.plataforma;"
                                                        />
                                                        </CCol>
                                                </CRow>
                                            </CCol>
                                        </CRow>
                                    </span>

                                    <span slot="enviar" slot-scope="empresa">
                                        <CButton class="btnPrincipalVapp"
                                            v-show="empresa.enviandoEmpresa">
                                            <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                            Enviando Empresa
                                        </CButton>
                                        <CButton class="btnPrincipalVapp"
                                        v-show="!empresa.enviandoEmpresa"
                                        v-c-tooltip.hover="{content:(empresa.userNotificar.length == 0)?'(!) OJO - No tiene usuario para revision':'Enviar a Revision', placement:'left'}" type="submit" size="sm" color="success" :disabled="(empresa.estado==2 || empresa.estado==0)?false:true" 
                                        @click="enviarEmpresa(empresa)">
                                            <span v-show="empresa.userNotificar.length == 0" style="color:red; font-size:14px;font-weight: bold;">!</span> <CIcon name="cil-check-circle"/> Enviar
                                        </CButton>
                                    </span>

                                    <span slot="estado" slot-scope="empresa">
                                        <CBadge
                                            class="m-1"
                                            style="font-size:0.7rem; font-weight: normal;"
                                            v-c-tooltip.hover="{
                                                content: (empresa.estado==1)?'En Revisón':(empresa.estado==2)?'Rechazado '+ empresa.mensajeRespuesta+' ('+getDate(empresa.fechaMensaje)+')':(empresa.estado==3)?'Aceptado':'Sin Enviar',
                                                placement:'left'
                                            }"
                                            shape="pill" :color="(empresa.estado==1)?'info':(empresa.estado==2)?'danger':(empresa.estado==3)?'success':'secondary'">
                                            <!--{{(empresa.estado==1)?'En Proceso':(empresa.estado==2)?'Rechazado':(empresa.estado==3)?'Aceptado':'Sin Enviar'}}-->
                                            <CIcon v-if="empresa.estado==1" style="width:20px; height:20px;" :content="$options.freeSet.cilArrowCircleRight" />
                                            <CIcon v-else-if="empresa.estado==2" style="width:20px; height:20px;" :content="$options.freeSet.cilXCircle" />
                                            <CIcon v-else-if="empresa.estado==3" style="width:20px; height:20px;" :content="$options.freeSet.cilCheckCircle" />
                                            <CIcon v-else style="width:20px; height:20px;" :content="$options.freeSet.cilBan" />

                                        </CBadge>
                                        <CBadge
                                            v-show="empresa.periodoCerrado && empresa.estado==3"
                                            class="m-1"
                                            v-c-tooltip.hover="{
                                                content:`Periodo Cerrado ${formatFechaDocumento(empresa.fechaPeriodoCerrado)}`, 
                                                placement:'left'
                                            }"
                                            shape="pill" 
                                            style="font-size:0.7rem; font-weight: normal; background-color:#29235C; color:white"
                                            >
                                            <CIcon style="width:20px; height:20px;" :content="$options.freeSet.cilLockLocked" />
                                        </CBadge><!--cilRoom cilDoor-->

                                        <CButton
                                            v-show="!empresa.periodoCerrado && empresa.estado==3"
                                            shape="pill"
                                            v-c-tooltip.hover="{content:'Cerrar Periodo', placement:'left'}" 
                                            style="font-size:11px;padding:1px"
                                            class="btnPrincipalVapp"
                                            @click="cerrarPeriodo(empresa)">
                                            <CIcon style="width:20px; height:20px;" :content="$options.freeSet.cilDoor" />
                                        </CButton>
                                        <CButton
                                            v-show="empresa.periodoCerrado && empresa.estado==3"
                                            shape="pill"
                                            v-c-tooltip.hover="{content:'Abrir Periodo', placement:'left'}" 
                                            style="font-size:11px;padding:1px"
                                            class="btnPrincipalVapp"
                                            @click="abrirPeriodo(empresa)">
                                            <CIcon style="width:20px; height:20px;" :content="$options.freeSet.cilRoom" />
                                        </CButton>



                                    </span>
                                    <div slot="expandedRowRender"
                                        slot-scope="empresa" style="width:99%; margin: 0">
                                        <CRow v-show="(empresa.trabajadores.length>0)">
                                            <CCol md="2">
                                                <CButton
                                                    v-c-tooltip.hover="{content: empresa.txtEnviarTodos, placement:'left'}" 
                                                    style="font-size:11px;"
                                                    class="btnPrincipalVapp m-2"
                                                    v-show="empresa.hayDocumentosTrabajador"
                                                    :disabled="empresa.isActualizandoDocumentos || empresa.isLoadingEnvioTodos"
                                                    @click="enviaraTodos(empresa)"
                                                    >
                                                    <CIcon v-show="empresa.isLoadingEnvioTodos" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                    Enviar Documentos<!--{{empresa.txtEnviarTodos}}-->
                                                </CButton>
                                                <!--v-show="empresa.mostrarMensajeActualizacionDocumentos"-->
                                            </CCol>
                                            <CCol md="2">
                                                <!--
                                                    v-show="empresa.hayDocumentosTrabajador"-->
                                                <CButton 
                                                    style="font-size:11px;"
                                                    type="submit" 
                                                    class="btnNormalVapp2 m-2"
                                                    size="sm"
                                                    v-c-tooltip.hover="{content: empresa.txtActualizarDocs, placement:'down'}" 
                                                    :disabled="empresa.isActualizandoDocumentos || empresa.periodoCerrado"
                                                    @click="actualizarDocumentosEmpresa(empresa)">
                                                    <CIcon 
                                                        :content="$options.freeSet.cilLoopCircular" :class="(empresa.isActualizandoDocumentos)?'imgr':''" />
                                                    Actualizar Documentos
                                                    <!--<CIcon :content="verOpcionesDescargas?$options.freeSet.cilArrowThickFromRight:$options.freeSet.cilArrowThickFromLeft" />-->
                                                </CButton>
                                                
                                                <CIcon 
                                                    v-show="empresa.mostrarMensajeActualizacionDocumentos"
                                                    v-c-tooltip.hover="{content: empresa.mensajeActualizacionDocs, placement:'down'}" 
                                                    :content="$options.freeSet.cilInfo" />
                                            </CCol>
                                            <CCol md="2">
                                                <CButton 
                                                    style="font-size:11px;"
                                                    :disabled="empresa.isActualizandoDocumentos"
                                                    v-show="empresa.hayDocumentosTrabajador"
                                                    v-c-tooltip.hover="{content:'Descargar todos los documentos', placement:'bottom'}" 
                                                    type="submit" 
                                                    class="m-2"
                                                    :class="empresa.verOpcionesDescargas?'btnNormalVapp2':'btnPrincipalVapp'"
                                                    size="sm"
                                                    @click="empresa.verOpcionesDescargas = !empresa.verOpcionesDescargas">
                                                    
                                                    {{empresa.txtDescargarDocumentos}} <CIcon :content="empresa.verOpcionesDescargas?$options.freeSet.cilArrowThickFromRight:$options.freeSet.cilArrowThickFromLeft" />
                                                </CButton>
                                            </CCol>
                                            <CCol md="6" v-show="empresa.verOpcionesDescargas">
                                                <CRow v-show="empresa.isDescargando">
                                                    <CCol sm="6">
                                                        <CButton block >
                                                            <CIcon :content="$options.freeSet.cilCloudDownload" :class="(empresa.isDescargando)?'imgr':''" /> {{empresa.msjDescargando}}
                                                        </CButton>
                                                    </CCol>
                                                </CRow>
                                                <CRow v-show="!empresa.isDescargando">
                                                    <CCol sm="12">
                                                        <CButton 
                                                            style="font-size:11px;"
                                                            v-show="empresa.totalTrabajadoresDocumentos>1"
                                                            v-c-tooltip.hover="{content:'Descargar un Archivo con todos los documentos', placement:'top'}" 
                                                            type="submit" 
                                                            class="m-2 float-left btnPrincipalVapp"
                                                            @click="descargarArchivo('merge',empresa)">
                                                            Unificar Documentos
                                                        </CButton>
                                                        <CButton 
                                                            style="font-size:11px;"
                                                            v-c-tooltip.hover="{content:'Descargar todos los documentos comprimidos', placement:'bottom'}" 
                                                            type="submit"
                                                            class="m-2 float-left btnPrincipalVapp"
                                                            @click="descargarArchivo('zip',empresa)">
                                                            Documentos Comprimidos
                                                        </CButton>
                                                    </CCol>
                                                    
                                                </CRow>
                                                <!--<CRow v-show="!isDescargando">
                                                    <CCol sm="6">
                                                        <CButton 
                                                            v-c-tooltip.hover="{content:'Descargar todos los documentos comprimidos', placement:'bottom'}" 
                                                            type="submit"
                                                            class="m-1"
                                                            color="primary"
                                                            @click="descargarArchivo('zip',empresa)">
                                                            documentos comprimidos
                                                        </CButton>
                                                    </CCol>
                                                </CRow>-->
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol md="12">
                                                <multiselect
                                                    style="min-width: 400px;"
                                                    class="mt-2 mb-2"
                                                    :id="empresa"
                                                    v-model="empresa.trabajadoresSelectedFiltro" 
                                                    :custom-label="customTrabajador" 
                                                    select-label=""
                                                    selectedLabel=""
                                                    deselect-label=""
                                                    track-by="nombreTrabajador" 
                                                    placeholder="Buscar Trabajador" 
                                                    open-direction="bottom" 
                                                    :options="empresa.trabajadoresFiltro" 
                                                    :multiple="true" 
                                                    :searchable="true"
                                                    :loading="empresa.isLoadingTrabajadoresFiltros" 
                                                    :internal-search="false" 
                                                    @search-change="asyncFind"
                                                    @select="filTrab"
                                                    @remove="rmvTrabSel">
                                                    <template slot="afterList">
                                                        <div v-observe-visibility="(isVisible, entry) => !empresa.isLoadingTrabajadoresFiltros?reachedEndOfList(isVisible, entry, empresa):''" v-if="hasNextPage(empresa)" />
                                                    </template>
                                                    <span slot="noResult">No se han encontrado trabajadores con esos datos</span>
                                                </multiselect>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol md="12">
                                                <a-table
                                                    :locale="localeTrabajadores"
                                                    :columns="columnasTrabajadores"
                                                    :data-source="empresa.trabajadores"
                                                    :pagination="empresa.paginacion"
                                                    :scroll="{ y: 200 }"
                                                    :loading="empresa.isLoadingTrabajadores"
                                                    class="components-table-demo-nested " 
                                                    size="small" 
                                                    style="overflow:auto; width:90%;"
                                                    @change="handleTableChange">
                                                    <span slot="tituloDoc">
                                                        Documento ({{empresa.totalTrabajadoresDocumentos}}/{{empresa.totalTrabajadores}})
                                                    </span>


                                                    <span slot="documento" slot-scope="trabajador">
                                                        <a v-if="trabajador.documento.hayDocumento" :href="trabajador.documento.urlDocumento" target="_blank" class="mr-4"
                                                            style="text-decoration: none; color:#0b7689;" 
                                                            v-c-tooltip.hover="{content:'Descargar Documento', placement:'rigth'}">
                                                            <CIcon :content="$options.freeSet.cilCloudDownload" />
                                                        </a>
                                                        <a v-if="trabajador.documento.hayDocumento" style="text-decoration: none; color:#0b7689" class="ml-4"
                                                            v-c-tooltip.hover="{content:'Ver Documento', placement:'rigth'}"
                                                            @click="seleccionarTrabajadores(empresa, trabajador)">
                                                            <CIcon :content="$options.freeSet.cilZoomIn" />
                                                        </a>
                                                        <CIcon
                                                            v-else
                                                            v-c-tooltip.hover="{content:trabajador.documento.nombreDocumento, placement:'left'}"
                                                            :content="$options.freeSet.cilMeh" />
                                                    </span>
                                                    <span slot="generacion" slot-scope="trabajador">
                                                        <CRow v-if="trabajador.documento.hayDocumento">
                                                            <CCol sm="12">
                                                                {{formatFechaDocumento(trabajador.documento.ultimaGeneracion)}}
                                                            </CCol>
                                                        </CRow>

                                                    </span>
                                                    
                                                    <span slot="estadoDocumento" slot-scope="trabajador">
                                                        <CBadge
                                                            style="font-weight: normal;"
                                                            shape="pill" 
                                                            :color="(trabajador.documento.estadoDocumento==1)?'info':
                                                                (trabajador.documento.estadoDocumento==2)?'danger':
                                                                    (trabajador.documento.estadoDocumento==3)?'success':'secondary'">
                                                                    
                                                            {{(trabajador.documento.hayDocumento)?((trabajador.documento.estadoDocumento==1)?'En Proceso':
                                                                (trabajador.documento.estadoDocumento==2)?'Rechazado':
                                                                    (trabajador.documento.estadoDocumento==3)?'Aceptado':'Sin Estado'):"Sin Documento"}}
                                                        </CBadge>
                                                    </span>
                                                </a-table>
                                            </CCol>
                                        </CRow>
                                   </div>
                                </a-table>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            
        </CRow>
        <!--}
        
            :trabajadores="trabajadores"
        -->
        <ModalPdfViewDocs
            :prevue="mostrarVisorPDF"
            :trabajadorprev="trabajadorSelectedModal"
            :empresa="empresaSelModal"
            :periodoSelected="periodoSelected"
            :mesSelected="mesSelected"
            :tipoDocumentoSelected="tipoDocumentoSelected"
            :web="this"
        />
        
        <Modal :enableClose="false" v-model="simpleDialog">
            
            <div class="vm-titlebar">
                <h3 class="vm-title">
                    Envío de empresa ({{empresaEnviar.codEmpresa}}) {{empresaEnviar.nombreEmpresa}}
                </h3>
                <!--<button
                    type="button"
                    class="vm-btn-close"
                    @click="simpleDialog = false"
                ></button>-->
            </div>
            <div class="vm-content">
                <slot v-if="!mailEmpresaOk">
                    <div v-if="empresaEnviar.userNotificar.length == 0">
                        <CRow>
                            <CCol md="12">
                                <CAlert v-show="true" color="warning">
                                    Esta empresa no tiene un usuario para su revisión, le recomendamos configurar un usuario revisión y asignarle a esta empresa
                                </CAlert>
                            </CCol>
                        </CRow>
                    </div>
                    <div v-else-if="!mailEmpresaOk">
                        <CRow>
                            <CCol md="12">
                                <CAlert v-show="true" color="warning">
                                    {{empresaEnviar.userNotificar.length>1?'Uno o más correos':'El correo del encargado'}} no se encuentra registrado o es invalido, ingrese a quién se debe enviar la notificación
                                </CAlert>
                            </CCol>
                        </CRow>
                        <CRow v-for="user in empresaEnviar.userNotificar" :key="user.idUser">
                            <CCol md="9">
                                <CInput
                                    horizontal
                                    :label="user.username"
                                    v-model="user.mailUser"
                                    placeholder="ingresar email encargado"
                                    :is-valid="user.mailValidado"
                                />
                            </CCol>
                            <CCol md="3">
                                <CButtonGroup class="mx-1">
                                    <CButton color="success" size="sm" @click="isEmailValido">
                                        <CIcon name="cil-check-circle"/>
                                    </CButton>
                                </CButtonGroup>
                            </CCol>
                        </CRow>
                    </div>
                    <!--<div>{{empresaEnviar}}</div>-->
                </slot>
                <slot v-else>
                    <CRow>
                        <CCol md="12">
                            <CAlert v-show="true" color="warning">
                                Se enviará a revision {{tipoDocumentoSelected.nombreDocumento}} de la empresa
                            </CAlert>
                        </CCol>
                    </CRow>
                    
                    <CRow v-for="user in empresaEnviar.userNotificar" :key="user.idUser">
                        
                        <CCol md="9">
                            <CInput
                                horizontal
                                :label="user.username"
                                v-model="user.mailUser"
                                type="email"
                                :disabled="!user.editCorreoEncargado"
                                placeholder="ingresar email encargado"
                            />
                        </CCol>
                        <CCol md="3" class="align-middle" style="vertical-align:middle">
                            <CButtonGroup class="mx-1">
                                <CButton color="success" size="sm" 
                                    @click="editarCorreoEmpresa(user)" v-show="!user.editCorreoEncargado">
                                    <CIcon name="cil-pencil"/>
                                </CButton>
                            </CButtonGroup>
                            
                            <CButtonGroup class="mx-1" v-show="user.editCorreoEncargado">
                                <CButton color="success" size="sm" @click="isEmailValido">
                                    <CIcon name="cil-check-circle"/>
                                </CButton>
                            
                                <CButton color="danger" size="sm" @click="cancelarEditarEmpresa(user)">
                                    <CIcon name="cil-x-circle"/>
                                </CButton>
                            </CButtonGroup>
                        </CCol>
                        
                    </CRow>
                    <CRow v-show="mostrarMensajeEnvioEmpresa">
                        <CCol md="12">
                            <CAlert v-show="true" :color="tipoMensaje">
                                {{mensajeRevision}}
                            </CAlert>
                        </CCol>
                    </CRow>
                </slot>
                
            </div>
            <div class="vm-footer">
                <CRow v-show="isLoadingEnviandoEmpresa">
                    <CCol md="12">
                        <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" /> {{msjEnviandoRevision}}
                    </CCol>
                </CRow>
                <CRow v-show="!isLoadingEnviandoEmpresa">
                    <CCol md="6" v-show="!editCorreoEncargado && mailEmpresaOk && !empresaEnviada">
                        <CButton type="submit" size="sm" color="success" class="float-left" v-show="!editCorreoEncargado && mailEmpresaOk && !empresaEnviada" @click="enviarRevision">
                            <CIcon name="cil-check-circle"/> Enviar a Revisión
                        </CButton>
                    </CCol>
                    <CCol md=6 v-show="mensajeCorreoInvalido">
                        <CAlert v-show="mensajeCorreoInvalido" color="danger">
                            Coreo Invalido
                        </CAlert>
                    </CCol>
                    <CCol :md="(mostrarMensajeEnvioEmpresa)?'12':'6'">
                        <CButton type="submit" size="sm" color="danger" class="float-right" 
                            @click="cancelarEnvio();simpleDialog = false">
                            <CIcon name="cil-x-circle"/> Salir
                        </CButton>
                    </CCol>
                </CRow> 
            </div>
        </Modal>
        
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    
    import cons from '@/const'
    import axios from "axios"

    import Multiselect from 'vue-multiselect'

    import VueModal from '@kouts/vue-modal';
    import '@kouts/vue-modal/dist/vue-modal.css';
    
    import { freeSet } from '@coreui/icons'

    import moment from 'moment'
    import { format, formatDistance, formatRelative, subDays } from 'date-fns'
    import es from 'date-fns/locale/es'
    window.locale = 'es'
    import ModalPdfViewDocs from "./componentes/ModalPdfViewDocs";
    
    import CChartLineSimple from "./componentes/CChartLineSimple"

    export default {
        name: 'RevisionDocumentos',
        freeSet,
        components: {
            Multiselect,
            'Modal': VueModal,
            ModalPdfViewDocs,
            CChartLineSimple
        },
        data () {
            return {
                urlBase: cons.port+"://" + cons.ipServer,
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
                isLoadingPeriodos: false,
                isLoadingMes: false,
                isLoadingTipoDocumentos: false,
                isLoadingEmpresas: false,
                //isLoadingTrabajadores: false,
                isLoadingEnviandoEmpresa: false,
                //isDescargando:false,
                //isActualizandoDocumentos:false,
                isRefrescando: false,
                isLoadingEmpresasInfo: false,

                empresasInfo: [],
                empSelected: [],
                
                msjEnviandoRevision: "Enviando...",
                //msjDescargando: "Generando Documento...",
                //txtActualizarDocs: "Actualizar Documentos",
                

                //verOpcionesDescargas: false,

                selectPeriodoActual: false,
                chxbPeriodoActual: false,
                isActualizandoEmpresas: false,

                
                textoBtnActualizarEmpresas: "Actualizar Empresas",

                filterData: "",
                editCorreoEncargado: false,
                modificarCorreoEmpresa: false,
                mensajeNotificacion: "",
                classActualizar: "",
                classRefrescarEmpresas: "",

                locale: {
                    filterConfirm: 'Filtrar',
                    filterReset: 'Limpiar',
                    emptyText: 'Seleccione sus opciones'
                },
                localeTrabajadores: {
                    emptyText: 'No hay trabajadores para el periodo seleccionado'
                },


                linkPdfVer: "",
                

                simpleDialog: false,
                empresaEnviar: {userNotificar: {}},

                periodoSelected: null,
                mesSelected: null,
                tipoDocumentoSelected: null,

                periodos: [],

                tipoDocumentos:[],

                columns: [
                    { slots: { title: 'customTitle' }, scopedSlots: { customRender: 'nombreEmpresa' }, width: '30%', ellipsis: true, onFilter: (value, record)=>record.idEmpresa == value},
                    { title: 'Rut Empresa', dataIndex: 'rutEmpresa', width: '15%', ellipsis: true, onFilter: (value, record)=>record.rutEmpresa == value},
                    //{ title: 'Notificar por', key: 'notificarPor', scopedSlots: { customRender: 'notificarPor' }, width: '30%', align: 'center', ellipsis: true},
                    { title: 'Enviar a Revisión', scopedSlots: { customRender: 'enviar' }, width: '20%', align: 'center', ellipsis: true},
                    { title: 'Estado', scopedSlots: { customRender: 'estado' }, width: '20%', ellipsis: false},
                ],
                columnasTrabajadores: [
                    { title: 'Rut', dataIndex: 'rutTrabajador', key: 'rutTrabajador', width: '15%', ellipsis: true},
                    { title: 'Trabajador', dataIndex: 'nombreTrabajador', key: 'nombreTrabajador',  width: '30%', ellipsis: true},
                    { slots: { title: 'tituloDoc' }, key: 'documento', scopedSlots: { customRender: 'documento' }, width: '15%', align: 'center'},
                    { title: 'Última Generación', key: 'generacion', scopedSlots: { customRender: 'generacion' }, width: '30%', align: 'center', ellipsis: true},
                    { title: 'Estado Documento', key: 'estadoDocumento', scopedSlots: { customRender: 'estadoDocumento' }, width: '10%', align: 'center', ellipsis: false}
                ],
                
                empresas: [],
                empresasFiltradas: [],

                mailEmpresaRespaldo: "",
                mailEmpresaOk: false,

                mensajeCorreoInvalido: false,
                mailValido: false,
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                mostrarMensajeEnvioEmpresa: false,
                mensajeRevision: "",
                tipoMensaje: "warning",
                empresaEnviada: false,

                respEmpresaEnviar: {},

                
                emFlt: [],

                rqstEmps: null,

                paginacionEmpresas: { pageSize: 30 },

                trabajadoresFiltro: [],
                trabajadoresFiltrados: [],
                trabajadoresSelectedFiltro: [],

                trabajadoresSelectedModal: [],

                mostrarMensajes: false,
                columnasMensajesAct: [
                    { title: 'Cod Empresa', dataIndex: 'codEmpresa', width: '15%', ellipsis: true, align: 'center'},
                    { title: 'Mensajes', scopedSlots: { customRender: 'mensajes' }, width: '70%', align: 'left'},
                ],
                mensajesActualizacion: [],

                
                visorPdf: false,
                mostrarVisorPDF: false,
                rqstTrabsModal: null,
                empresaSelModal: null,
                trabajadorSelectedModal: {},
                trabajadoresModal: [],
                isLoadingTrabajadoresModal: false,
                currentPageTrabModal: 1,
                totalPagesTrabModal: 20,
                
            }
        },
        created: function(){},
        beforeMount() {
            let cookieUsername = this.$cookie.get('userLogginToken')
            if(cookieUsername === null || cookieUsername === ""){
                this.$router.push("/pages/login");
            }
            this.actualizar()

            this.obtenerPeriodos()
            this.obtenerDocumentos()
            this.obtenerSoloInfoEmpresas()

        },
        mounted(){
        },
        methods: {
            cerrarPeriodo: function(empresa){
                var url = cons.port+"://" + cons.ipServer + "/abrir_cerrar_periodo_empresa/" + empresa.idEmpresa + "/" + this.mesSelected.valor + "/" + this.periodoSelected.valor + "/" + 2;//2 - cerrar

                axios({
                    method: "POST",
                    url: url,
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    }).then((result) => {
                        
                        this.$notification.success(`Se ha Cerrado el periodo ${this.mesSelected.nombreMes}-${this.periodoSelected.valor}, ${empresa.nombreEmpresa}`, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                        empresa.periodoCerrado = true;
                        empresa.fechaPeriodoCerrado = result.data.fechaModificacion;
                    },
                    (error) => {
                        
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                    })
                    .finally(() => {
                    });
            },
            abrirPeriodo: function(empresa){

                var url = cons.port+"://" + cons.ipServer + "/abrir_cerrar_periodo_empresa/" + empresa.idEmpresa + "/" + this.mesSelected.valor + "/" + this.periodoSelected.valor + "/" + 1;//1 - abrir

                axios({
                    method: "POST",
                    url: url,
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    }).then((result) => {
                        this.$notification.success(`Se ha Abierto el periodo ${this.mesSelected.nombreMes}-${this.periodoSelected.valor}, ${empresa.nombreEmpresa}`, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                        empresa.periodoCerrado = false;
                    },
                    (error) => {
                        
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                    })
                    .finally(() => {
                    });
            },
            rmvTrabSel: function(trab, empresa){
                for(var indx=0; indx <= empresa.trabajadoresFiltrados.length; indx++){
                    if(empresa.trabajadoresFiltrados[indx].rutTrabajador == trab.rutTrabajador){
                        empresa.trabajadoresFiltrados.splice(indx, 1)
                        break;
                    }
                }
                if(this.mesSelected != null && this.periodoSelected != null)
                    this.obtenerTrabajadores(true, empresa)

                /*for(var indx=0;indx<=this.emFlt.length;indx++){
                    if(this.emFlt[indx].idEmpresa == emp.idEmpresa){
                        this.emFlt.splice(indx, 1)
                        break;
                    }
                }

                if(this.mesSelected != null && this.periodoSelected != null)
                    this.obtenerEmpresas(this.tipoDocumentoSelected)*/
                
            },
            filTrab: function(trab, empresa){
                empresa.trabajadoresFiltrados.push(trab)
                empresa.paginacion.current = 1
                this.obtenerTrabajadores(true, empresa)
                /*if(this.mesSelected != null && this.periodoSelected != null)
                    this.obtenerEmpresas(this.tipoDocumentoSelected)*/
            },
            reachedEndOfList(reached, entry, empresa) {
                if (reached) {
                    if(this.hasNextPage(empresa)){
                        this.getTrabajadores(empresa)
                    }
                }
            },
            reachedEndOfListTrabajadoresModal(reached, entry, empresa) {
                if (reached) {
                    if(this.hasNextPage(empresa)){
                        this.getTrabajadoresModal(empresa)
                    }
                }
            },
            hasNextPageModalTrab()  { return this.currentPageTrabModal + 1 <=this.totalPagesTrabModal },
            hasNextPage(empresa) { return empresa.currentPage + 1 <=empresa.totalPages },
            asyncFind: function(query, empresa){//recibe el id,por lo que se seteo el id por la empresa para poder pasar el valor
                
                empresa.strFiltroTrabajadores = query
                empresa.currentPage = 1
                empresa.trabajadoresFiltro = [{ rutTrabajador: '0', nombreTrabajador: 'Buscando...', documento:{hayDocumento: false},  $isDisabled: true }]
                this.getTrabajadores(empresa)
            },
            
            getTrabajadores: function(empresa){

               

                if(empresa.rqstTrabs != null){
                    empresa.rqstTrabs.cancel()
                    empresa.rqstTrabs.msg = "cancelado";
                    empresa.rqstTrabs = null;
                    
                    empresa.isLoadingTrabajadoresFiltros = true;
                }
                const axiosSource = axios.CancelToken.source();
                empresa.rqstTrabs = { cancel: axiosSource.cancel, msg: "Cargando..." };

                empresa.isLoadingTrabajadoresFiltros = true;

                var url = cons.port+"://" +
                    cons.ipServer + "/get_trabajadores_empresa/" +
                    empresa.idEmpresa+
                    "/" +
                    this.tipoDocumentoSelected.valor +
                    "/" +
                    this.mesSelected.valor + "/" + this.periodoSelected.valor;
            
                axios({
                method: "POST",
                url: url,
                cancelToken: axiosSource.token,
                "data": {
                    "paginacionTrabajadores": {
                        "strFiltro": empresa.strFiltroTrabajadores,
                        "actual": empresa.currentPage,
                        "tamanioPagina": 10
                    }
                },
                headers: {
                    Authorization: `${this.tokenLogin}`,
                },
                }).then((result) => {
                    empresa.totalPages = Number((result.data.totalTrabajadores/10).toFixed(0))
                    if(empresa.trabajadoresFiltro.length == 1 && empresa.trabajadoresFiltro[0].rutTrabajador == '0'){
                        empresa.trabajadoresFiltro = []
                    }

                    empresa.trabajadoresFiltro = empresa.trabajadoresFiltro.concat(result.data.trabajadores)
                    empresa.currentPage++
                    
                    empresa.isLoadingTrabajadoresFiltros = false;
                    empresa.rqstTrabs = null;
                },
                cancel =>{

                },
                (error) => {
                    
                    empresa.isLoadingTrabajadoresFiltros = false;
                    empresa.rqstTrabs = null;

                }
                )
                .finally(() => {
                });
            },

            enviaraTodos: function(empresa){
                var msjOriginal = empresa.txtEnviarTodos
                empresa.isLoadingEnvioTodos = true
                empresa.txtEnviarTodos = "enviando"
                var url = cons.port+"://" + cons.ipServer + "/" + "enviar_documento_trabajador/"

                var trabajadores = []
                if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
                    empresa.trabajadoresFiltrados.forEach(trabajador => {
                        trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
                    });
                }

                axios({
                    method: "POST",
                    url: url,
                    "data": {
                        "trabajadoresEnviar": {
                        "enviarTodos": true,
                        "idEmpresa": empresa.idEmpresa,
                        "anioPeriodo": this.periodoSelected.valor,
                        "mesPeriodo": this.mesSelected.valor,
                        "tipoDoc": this.tipoDocumentoSelected.valor,
                        "trabajadores":trabajadores
                        }
                    },
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    })
                    .then((result) => {
                        this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                        );
                        //this.obtenerTrabajadores(true, empresa)
                    },
                    (error) => {
                        this.$notification.error(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                        );
                    }
                    )
                    .finally(() => {
                        empresa.txtEnviarTodos = msjOriginal
                        empresa.isLoadingEnvioTodos = false
                    });

            },
            rmvEmpSel: function(emp){
                for(var indx=0;indx<=this.emFlt.length;indx++){
                    if(this.emFlt[indx].idEmpresa == emp.idEmpresa){
                        this.emFlt.splice(indx, 1)
                        break;
                    }
                }

                if(this.mesSelected != null && this.periodoSelected != null)
                    this.obtenerEmpresas(this.tipoDocumentoSelected)
                
            },
            filtrarEmpr: function(emp){
                this.emFlt.push(emp)
                if(this.mesSelected != null && this.periodoSelected != null)
                    this.obtenerEmpresas(this.tipoDocumentoSelected)
            },
            customLabelEmp (empresa) {
                return `(${empresa.codEmpresa}) ${empresa.nombreEmpresa}`;
            },
            
            customTrabajador: function(trabajador) {
                if(trabajador.rutTrabajador == '0'){
                    return 'Buscando...'
                }else {
                    return `${trabajador.rutTrabajador} – ${trabajador.nombreTrabajador} ${(!trabajador.documento.hayDocumento)?"(Sin Documento)":""}`
                }
            },

            seleccionarTrabajadores: function(empresa, trabajador){
                //console.log(empresa)
                
                //console.log(trabajador)
                //this.trabajadoresModal = trabajadores
                this.empresaSelModal = empresa
                this.trabajadorSelectedModal = trabajador
                //this.getTrabajadoresModal()
                //this.trabajadorSelected = trabajador
                this.mostrarVisorPDF = true

            },
            getTrabajadoresModal: function(empresa){
                
                this.isLoadingTrabajadoresModal = true;

                var url = cons.port+"://" +
                    cons.ipServer + "/get_trabajadores_empresa/" +
                    this.empresaSelModal.idEmpresa+
                    "/" +
                    this.tipoDocumentoSelected.valor +
                    "/" +
                    this.mesSelected.valor + 
                    "/" + this.periodoSelected.valor;

                    if(this.rqstTrabsModal != null){
                        this.rqstTrabsModal.cancel()
                        this.rqstTrabsModal.msg = "cancelado";
                        this.rqstTrabsModal = null;
                    }
                    const axiosSource = axios.CancelToken.source();
                    this.rqstTrabsModal = { cancel: axiosSource.cancel, msg: "Cargando..." };
                
                    axios({
                    method: "POST",
                    url: url,
                    cancelToken: axiosSource.token,
                    "data": {
                        "paginacionTrabajadores": {
                            "strFiltro": this.strFiltroTrabajadores,
                            "actual": this.currentPageTrabModal,
                            "tamanioPagina": 10
                        }
                    },
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    }).then((result) => {


                        this.totalPagesTrabModal = Number((result.data.totalTrabajadores/10).toFixed(0))

                        this.trabajadoresModal = this.trabajadoresModal.concat(result.data.trabajadores)
                        this.currentPageTrabModal++
                    },
                    (error) => {

                    }
                    )
                    .finally(() => {
                    this.isLoadingTrabajadoresModal = false;
                    this.rqstTrabsModal = null;
                    });
                },
            


            formatFechaDocumento: function(fechaDoc){
                //return format(new Date(fechaDoc), 'EEE d LLL/yy H:mm:ss', {locale: es})//'dd/MM/yyyy' 'EEE d LLL/yy H:mm:ss'
                if(fechaDoc != null){
                    return formatDistance(new Date(fechaDoc), new Date(), { addSuffix: true, locale: es})//.isSame(moment().clone().startOf('day'), 'd')
                }
                 else{
                    return "Nunca"
                }
            },
            getDate: function(fecha){
                return formatDistance(new Date(fecha), new Date(), { addSuffix: true, locale: es})//.isSame(moment().clone().startOf('day'), 'd')
                
            },
            /*mostrarPdfModal: function(link, trabajador){
                if(!trabajador.documento.verDocumento){
                    this.linkPdfVer = link.replace("view", "preview");
                    trabajador.documento.verDocumento = !trabajador.documento.verDocumento
                    this.mostrarVisorPDF = true
                }
                else{
                    trabajador.documento.verDocumento = !trabajador.documento.verDocumento
                    this.mostrarVisorPDF = false
                }
                //this.visorPdf = true;
            },*/
            descargarArchivo: function(tipoDescarga, empresa){
                empresa.isDescargando = true
                
                var url = this.urlBase + `/descargar_documentos/${tipoDescarga}/${empresa.codEmpresa}/${this.tipoDocumentoSelected.valor}/${empresa.idEmpresa}/REMU/${this.mesSelected.valor}/${this.periodoSelected.valor}`
                var trabajadores = []
                if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
                    empresa.trabajadoresFiltrados.forEach(trabajador => {
                        trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
                    });
                }
                axios({
                    url: url,
                    method: 'POST',
                    "data": {
                        "infoTrabajadores": {
                            "trabajadoresSelected": [],
                            "trabajadores": trabajadores
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    },

                }).then((response) => {
                    //this.msjDescargando = "Iniciando Descarga"
                    this.$notification.success("Iniciando Descarga", {  timer: 10, position:"bottomRight", showCloseIcn:true});

                    const link = document.createElement('a')
                    link.href = response.data.link
                    link.download = response.data.nombre
                    link.click()
                    URL.revokeObjectURL(link.href)

                })
                .finally(() => {
                    empresa.isDescargando = false
                });
                
            },
            actualizar: function(){
                this.isActualizandoEmpresas = true
                this.textoBtnActualizarEmpresas = "Sincronizando Información Empresas"
                this.classActualizar = "imgr"
                this.mensajesActualizacion = []
                this.mostrarMensajes = false

                var url = this.urlBase + "/actualizar_bd/REMU"
                var periodo = null
                var mensaje

                if(this.periodoSelected != null && this.mesSelected != null){
                    periodo = `${this.periodoSelected.valor}-${this.mesSelected.valor}`
                }

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "periodo": periodo
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    mensaje = result.data
                    this.mensajesActualizacion = mensaje.mensajesEmpresa
                    
                    
                    this.$notification.success(mensaje.mensajeGeneral, 
                        {  
                            timer: 10, position:"bottomRight", 
                            
                        }
                    );
                }, error => {
                    mensaje = "Ups, Tuvimos un problema al actualizar, si el problema persiste contacte con nuestro soporte, Gracias."
                    
                    this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                })
                .finally(() => {
                    this.classActualizar = ""
                    this.isActualizandoEmpresas = false
                    this.textoBtnActualizarEmpresas
                    this.textoBtnActualizarEmpresas = "Actualizar Empresas"
                });

            },
            isEmailValido: function() {
                var hayInvalido = false

                this.empresaEnviar.userNotificar.forEach(user => {
                    if(!this.reg.test(user.mailUser) || user.mailUser == ' ' || user.mailUser == null){
                        this.mailEmpresaOk = false
                        this.mailValido = false
                        user.mailValidado = false
                        this.modificarCorreoEmpresa = true
                        hayInvalido = true
                    } else {
                        user.mailValidado = true
                        user.editCorreoEncargado = false
                    }

                })

                if(!hayInvalido){
                    this.mailEmpresaOk = true
                    this.mailValido = true
                }


                /*if(this.empresaEnviar.userNotificar.mailUser == "" || !this.reg.test(this.empresaEnviar.userNotificar.mailUser)){
                    this.mensajeCorreoInvalido = true
                }
                else{
                    this.mailEmpresaOk = true
                    this.mensajeCorreoInvalido = false
                    this.editCorreoEncargado = false
                    this.mailEmpresaRespaldo = this.empresaEnviar.userNotificar.mailUser
                }*/
            },
            editarCorreoEmpresa: function(user){
                user.editCorreoEncargado = !user.editCorreoEncargado
                this.modificarCorreoEmpresa = true
                user.mailRespaldo = user.mailUser

            },
            cancelarEditarEmpresa: function(user){
                if(user.mailUser != user.mailRespaldo)
                    user.mailUser = user.mailRespaldo
                
                user.editCorreoEncargado = false
            },

            filtrar: function(value){
                const busqueda = this.filterData.toLowerCase().trim();

                if(!busqueda){ this.empresasFiltradas = this.empresas}

                this.empresasFiltradas = this.empresas.filter(
                    c => c.idEmpresa.toLowerCase().indexOf(busqueda) >-1 || 
                    c.nombreEmpresa.toLowerCase().indexOf(busqueda) >-1 || 
                    c.rutEmpresa.toLowerCase().indexOf(busqueda) >-1)
            },

            actualizarDocumentosEmpresa: function(empresa){
                empresa.isActualizandoDocumentos = true
                empresa.txtActualizarDocs = "Revisando Documentos"
                var url =  this.urlBase + "/actualizar_documentos_empresa/"

                var trabajadores = []
                if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
                    empresa.trabajadoresFiltrados.forEach(trabajador => {
                        trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
                    });
                }

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "infoActualizar": {
                            "idEmpresa": empresa.idEmpresa,
                            "tipoBD": "REMU",
                            "tipoDocumentos": this.tipoDocumentoSelected.valor,
                            "mes": this.mesSelected.valor,
                            "anio": this.periodoSelected.valor,
                            "trabajadores": trabajadores
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    empresa.mensajeActualizacionDocs = result.data
                    empresa.mostrarMensajeActualizacionDocumentos = true
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                }, error => {
                    this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
                })
                .finally(() => {
                    empresa.isActualizandoDocumentos = false
                    if(record.trabajadoresFiltrados.length > 0 ){
                        record.txtActualizarDocs = "Actualizar Documentos Trabajadores Seleccionados"
                    } else{
                        record.txtActualizarDocs = "Actualizar Documentos"
                    }
                    
                });

            },


            seleccionarPeriodoActual: function(){
                var anioActual = new Date().getFullYear()
                var mesActual = new Date().getMonth()//se obtiene el anterior

                if(this.selectPeriodoActual){
                    for(var periodo in this.periodos){
                        if(this.periodos[periodo].valor == anioActual){

                            this.periodoSelected = this.periodos[periodo]
                            var mesEncontrado = false

                            for(var mes in this.periodoSelected.meses){

                                if(this.periodoSelected.meses[mes].valor == mesActual){
                                    this.mesSelected = this.periodoSelected.meses[mes]
                                    mesEncontrado = true
                                    break
                                }
                            }
                            if(mesEncontrado)
                                break
                        }
                    }
                    this.tipoDocumentoSelected = this.tipoDocumentos[0]
                    this.obtenerEmpresas(this.tipoDocumentoSelected)
                }

            },

            seleccionarPeriodo: function(){
                this.mesSelected = null
                this.empresas = []
                this.empresasFiltradas = []
            },
            seleccionarMeses: function(mes){
                this.mesSelected = mes
                if(this.tipoDocumentoSelected != null){
                    this.obtenerEmpresas(this.tipoDocumentoSelected)
                }
            },
            obtenerPeriodos: function(){

                this.isLoadingPeriodos = true
                var url = this.urlBase + "/get_periodos/"

                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.periodos = result.data
                }, error => {
                    this.mensajeNotificacion = "Ups, Tuvimos un problema al obtener los periodos, si el problema persiste contacte con nuestro soporte, Gracias."
                })
                .finally(() => {
                    this.isLoadingPeriodos = false
                });
            },
            obtenerDocumentos: function(){
                
                this.isLoadingTipoDocumentos = true
                var url =  this.urlBase + "/get_tipo_documentos/"

                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.tipoDocumentos = result.data
                    if(this.tipoDocumentos.length == 1){
                        this.tipoDocumentoSelected = this.tipoDocumentos[0]
                    }
                }, error => {
                    this.mensajeNotificacion = "Ups, Tuvimos un problema al obtener los Documentos, si el problema persiste contacte con nuestro soporte, Gracias."
                })
                .finally(() => {
                    this.isLoadingTipoDocumentos = false
                });
            },
            obtenerSoloInfoEmpresas: function(){
                this.isLoadingEmpresasInfo = true
                var url = cons.port+"://" + cons.ipServer + "/get_empresas_info/REMU";
                
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.empresasInfo = result.data;

                }, error => {
                    let mensaje = `Problema al obtener empresas , ${error}`
                    this.textoSinEmpresas = mensaje
                })
                .finally(() => {
                    this.isLoadingEmpresasInfo = false
                });
            },
            cambioPaginaEmpresas: function(pagination, filters, sorter, filasActuales){
                this.paginacionEmpresas = pagination
                this.obtenerEmpresas(this.tipoDocumentoSelected)
            }, 
            obtenerEmpresas: function(tipoDoc){
                
                if(this.rqstEmps != null){
                    this.rqstEmps.cancel()
                    this.rqstEmps.msg = "cancelado";
                    this.rqstEmps = null;
                    
                    this.isLoadingEmpresas = false
                }

                const axiosSource = axios.CancelToken.source();
                this.rqstEmps = { cancel: axiosSource.cancel, msg: "Cargando..." };
                
                this.empresas = []
                this.empresasFiltradas = []
                this.isLoadingEmpresas = true
                var url =  this.urlBase + "/get_empresas_documentos/"+this.periodoSelected.valor+"/"+this.mesSelected.valor+"/"+tipoDoc.valor+"/REMU"
                
                
                axios({
                    method: "POST", 
                    "url": url,
                    cancelToken: axiosSource.token,
                    "data": {
                        "info":{
                            "empSelecteds": this.emFlt,
                            "paginacionEmpresas": {
                                "actual": this.paginacionEmpresas.current,
                                "tamanioPagina": this.paginacionEmpresas.pageSize
                            }
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.empresas = result.data.empresas
                    this.empresasFiltradas = result.data.empresas 

                    for(var colum in this.columns){
                        
                        if(this.columns[colum].key === "rutEmpresa"){
                            this.columns[colum].filters = result.data.filtros.rutEmpresa
                        } else if(this.columns[colum].key === "nombreEmpresa"){
                            this.columns[colum].filters = result.data.filtros.nombreEmpresa
                        }
                    }

                    if(this.empresas.length<=0)
                        this.locale.emptyText = "No hay empresas para mostrar"

                    const pagination = { ...this.paginacionEmpresas };
                    pagination.total = result.data.totalEmpresas
                    this.paginacionEmpresas = pagination

                    this.isRefrescando = false
                    this.isLoadingEmpresas = false
                    this.classRefrescarEmpresas = ""
                    this.selectPeriodoActual = false
                    this.rqstEmp = null
                }, 
                cancel => {
                    console.log("cancelado")
                },
                error => {
                    this.mensajeNotificacion = "Ups, Tuvimos un problema al obtener las empresas en este periodo, si el problema persiste contacte con nuestro soporte, Gracias."
                    console.log(error)
                    console.log(error.response)
                    this.isRefrescando = false
                    this.isLoadingEmpresas = false
                    this.classRefrescarEmpresas = ""
                    this.selectPeriodoActual = false
                    this.rqstEmp = null
                })
                .finally(() => {
                    /*this.isRefrescando = false
                    this.isLoadingEmpresas = false
                    this.classRefrescarEmpresas = ""
                    this.selectPeriodoActual = false
                    this.rqstEmp = null*/
                });
            },
            
            handleTableChange: function(pagination, filters, sorter, filasActuales){
                pagination.empresa.paginacion = pagination
                this.obtenerTrabajadores(true, pagination.empresa)

            },
            expandirEmpresa: function(expanded, record){
                if(expanded){
                    //if(!record.periodoCerrado)
                    //    this.actualizarDocumentosEmpresa(record)

                    this.obtenerTrabajadores(expanded, record)
                    this.getTrabajadores(record)
                    
                }
            },

            obtenerTrabajadores: function(expanded, record){
                if(expanded){
                    
                    if(record.trabajadoresFiltrados.length > 0 ){
                        record.txtEnviarTodos = "Enviar Documentos a Trabajadores Seleccionados"
                        record.txtActualizarDocs = "Actualizar Documentos Trabajadores Seleccionados"
                        record.txtDescargarDocumentos = "Descargar Documentos Trabajadores Seleccionados"
                    } else{
                        record.txtEnviarTodos = record.txtEnviarTodosResp
                        record.txtActualizarDocs = "Actualizar Documentos"
                        record.txtDescargarDocumentos = "Descargar Documentos"
                    }

                    record.isLoadingTrabajadores = true
                    var url = this.urlBase + "/get_trabajadores_empresa/"
                    +record.idEmpresa+"/"
                    +this.tipoDocumentoSelected.valor+"/"
                    +this.mesSelected.valor+"/"
                    +this.periodoSelected.valor
                    /*+"/"
                    +record.paginacion.current+"/"
                    +record.paginacion.pageSize
                    
                    
                    "data": {
                            "paginacionTrabajadores": {
                                "actual": record.paginacion.current,
                                "tamanioPagina": record.paginacion.pageSize
                            }
                        },
                    */
                    
                    axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "paginacionTrabajadores": {
                                "actual": record.paginacion.current,
                                "tamanioPagina": record.paginacion.pageSize,
                                "filtrosTrabajadores": record.trabajadoresFiltrados
                            }
                        },
                        "headers": {
                            'Authorization': `${this.tokenLogin}`
                        }
                    }).then(result => {

                        record.trabajadores = result.data.trabajadores
                        record.totalTrabajadoresDocumentos = result.data.totalDocumentosTrab
                        record.totalTrabajadores = result.data.totalTrabajadores

                        if(record.totalTrabajadoresDocumentos >0){
                            record.hayDocumentosTrabajador = true
                        }
                        /*
                        record.totalTrabajadores = record.trabajadores.length
                        record.totalTrabajadoresDocumentos = 0
                        record.trabajadores.forEach(trab =>{
                            if(trab.documento.hayDocumento){
                                record.hayDocumentosTrabajador = true
                                record.totalTrabajadoresDocumentos++
                            }
                        })*/
                        const pagination = { ...record.paginacion };
                        pagination.total = result.data.totalTrabajadores
                        pagination.empresa = record
                        record.paginacion = pagination
                        //record.totalTrabajadores
                        /*const pagination = { ...record.paginacion };
                        pagination.total = result.data.totalTrabajadores
                        pagination.empresa = record
                        record.paginacion = pagination*/

                    }, error => {
                        this.mensajeNotificacion = "Ups, Tuvimos un problema al obtener los Documentos, si el problema persiste contacte con nuestro soporte, Gracias."
                    })
                    .finally(() => {
                        record.isLoadingTrabajadores = false
                    });
                }
            },

            
            cancelarEnvio: function(){
                this.mailEmpresaOk = true
                this.mensajeCorreoInvalido = false
                this.mailValido = true
                //this.mailEmpresaRespaldo = ""
                this.modificarCorreoEmpresa = false
                this.empresaEnviada = false
                this.mostrarMensajeEnvioEmpresa = false

                this.empresaEnviar.userNotificar.forEach(user => {
                    user.mailUser = user.mailRespaldo
                })
                this.respEmpresaEnviar = {}
            },
            enviarEmpresa: function(empresa){

                this.respEmpresaEnviar = empresa

                this.mailEmpresaOk = true
                this.mensajeCorreoInvalido = false
                this.mailValido = true
                //this.mailEmpresaRespaldo = ""
                this.modificarCorreoEmpresa = false
                this.empresaEnviada = false
                this.mostrarMensajeEnvioEmpresa = false

                if(empresa.userNotificar.length == 0){

                    this.mailEmpresaOk = false
                    this.mailValido = false
                    this.modificarCorreoEmpresa = true

                } else{

                    empresa.userNotificar.forEach(user => {

                        if(!this.reg.test(user.mailUser) || user.mailUser == ' ' || user.mailUser == null){
                            
                            this.mailEmpresaOk = false
                            this.mailValido = false
                            user.mailValidado = false
                            this.modificarCorreoEmpresa = true
                            
                        } else {
                            user.mailValidado = true
                        }

                    })
                    /*if(!this.reg.test(empresa.userNotificar.mailUser) 
                        || empresa.userNotificar.mailUser == ' ' 
                        || empresa.userNotificar.mailUser == null){
                        this.mailEmpresaOk = false
                        this.mailValido = false
                        this.modificarCorreoEmpresa = true
                    }*/
                }

                this.empresaEnviar = empresa
                //this.mailEmpresaRespaldo = empresa.userNotificar.mailUser
                this.simpleDialog = true
            },
            enviarRevision: function(){

                this.isLoadingEnviandoEmpresa = true
                this.empresaEnviar.enviandoEmpresa = true
                
                
                var url = this.urlBase + "/enviar_empresa_revision/"
                /*url += this.empresaEnviar.idEmpresa+"/" //<id_empresa>
                url += this.empresaEnviar.userNotificar.idUser +"/" //id_encargado
                url += this.empresaEnviar.userNotificar.mailUser+"/" //mail_encargado
                url += this.empresaEnviar.notificar.mail+"/" //notificar_mail
                url += this.empresaEnviar.notificar.plataforma+"/" //notificar_plat
                url += this.modificarCorreoEmpresa+"/" //actualiza_correo
                url += this.mesSelected.valor+"/" //mes_periodo
                url += this.periodoSelected.valor+"/" //anio_periodo
                url += this.tipoDocumentoSelected.valor //tipo_documento*/
                
                this.simpleDialog = false

                this.$notification.success(
                    `Enviando empresa ${this.empresaEnviar.codEmpresa}`,
                    { timer: 10, position: "bottomRight" }
                );
               
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "datosEnvio": {
                            "modificarCorreoEmpresa": this.modificarCorreoEmpresa,
                            "tipoDocumento": this.tipoDocumentoSelected.valor,
                            "mesPeriodo": this.mesSelected.valor,
                            "anioPeriodo": this.periodoSelected.valor,
                            "empresaEnviar": {
                                "idEmpresa": this.empresaEnviar.idEmpresa,
                                "userNotificar": this.empresaEnviar.userNotificar,
                                "notificar": this.empresaEnviar.notificar
                            }
                        }
                        },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    /*this.mensajeRevision = result.data.mensaje
                    this.mostrarMensajeEnvioEmpresa = true
                    this.tipoMensaje = "success"
                    this.empresaEnviada = true*/

                    this.empresas[this.empresas.indexOf(this.empresaEnviar)].estado = result.data.estadoEmpresa

                    this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );
                    
                    
                }, error => {
                    this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );
                    
                })
                .finally(() => {
                    this.isLoadingEnviandoEmpresa = false
                    this.empresaEnviar.enviandoEmpresa = false
                });
            },
            
            refrescarEmpresas: function(){
                this.classRefrescarEmpresas = "imgr"
                this.isRefrescando = true
                this.obtenerEmpresas(this.tipoDocumentoSelected)
            },
        }
        
    }
</script>

<style>
/*
:style="verOpcionesDescargas?'background-color: #461A3B; border-color:#461A3B':'background-color:#29235C;border-color:#29235C'"
*/
/*.btnNormalVapp, .btnNormalVapp:hover,.btnNormalVapp:focus{
    color: white;
    background-color:#29235C;
    border-color:#29235C;
}*/
.c-switch-slider{
    border-color:#461A3B;
}
.btnNormalVapp2, .btnNormalVapp2:hover, .btnNormalVapp2:focus{
    color: white;
    background-color:#461A3B;
    border-color:#461A3B;
}
.ant-table-filter-dropdown .ant-dropdown-menu{
    max-height: 150px;
}
@keyframes rotate {from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}}
@-webkit-keyframes rotate {from {-webkit-transform: rotate(0deg);}
  to {-webkit-transform: rotate(360deg);}}
.imgr{
    -webkit-animation: 3s rotate linear infinite;
    animation: 3s rotate  linear infinite;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
}
.card-header h4{
    margin-bottom: 0;
}

.modal {
  min-width: 300px;
}
@media (min-width: 480px) {
  .modal.modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal.modal-lg,
  .modal.modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal.modal-xl {
    max-width: 1140px;
  }
}
.modal-footer {
  padding: 15px 0px 0px 0px;
  border-top: 1px solid #e5e5e5;
  margin-left: -14px;
  margin-right: -14px;
}
</style>